import { createApolloClient } from '../lib/createApolloClient'
import * as Sentry from '@sentry/nextjs'

const graphqlQuery = async (
  query,
  siteOrApi = null,
  variables = null,
  authToken = null
) => {
  const client = createApolloClient()
  const context = { site: siteOrApi, authToken }

  if (query.definitions[0].operation === 'mutation') {
    return client
      .mutate({
        mutation: query,
        context,
        variables,
      })
      .catch((error) => {
        return { error: error.message, originalError: error }
      })
  }

  const { data, error } = await client.query({
    query,
    context,
    variables,
  })
  if (error) {
    Sentry.addBreadcrumb({
      message: 'GraphQL request error',
      data: { query, siteOrApi, variables, error },
      level: 'error',
    })
    Sentry.captureException(error)
    console.error('graphQl request error', error)
  }

  return data
}

export default graphqlQuery
